module.exports = __webpack_public_path__ + "img/people.00c39653.png";